export const manifest = {
  screens: {
    scr_wxnbp6: { name: "Login", route: "/login", position: {"x":160,"y":8140} },
    scr_jc6tma: { name: "Onboarding · Profilo", route: "/onboarding", state: {"step":"profilo"}, position: {"x":160,"y":220} },
    scr_d4b2vx: { name: "Onboarding · Proprietà", route: "/onboarding", state: {"step":"proprieta"}, position: {"x":1560,"y":220} },
    scr_efldtk: { name: "Onboarding · Inserzioni", route: "/onboarding", state: {"step":"inserzioni"}, position: {"x":2960,"y":220} },
    scr_wfdb55: { name: "Onboarding · Vikey", route: "/onboarding", state: {"step":"vikey"}, position: {"x":4360,"y":220} },
    scr_275qvc: { name: "Onboarding · Pronto", route: "/onboarding", state: {"step":"done"}, position: {"x":5760,"y":220} },
    scr_hiospa: { name: "Host · Dashboard", route: "/dashboard", position: {"x":160,"y":2200} },
    scr_wy1yyd: { name: "Host · Pulizie", route: "/pulizie", position: {"x":1560,"y":2200}, width: 1125, height: 800 },
    scr_2mhfpz: { name: "Host · Pulizia completata", route: "/pulizia-dettaglio", state: {"status":"completata"}, position: {"x":2960,"y":2200}, width: 1119, height: 800 },
    scr_lcphm3: { name: "Host · Pulizia in corso", route: "/pulizia-dettaglio", state: {"status":"in_corso"}, position: {"x":14160,"y":2200} },
    scr_ifs7ub: { name: "Host · Pulizia pianificata", route: "/pulizia-dettaglio", state: {"status":"pianificata"}, position: {"x":12760,"y":2200} },
    scr_wyjele: { name: "Host · Pianificazione", route: "/pianificazione", position: {"x":4360,"y":2200} },
    scr_uxqp9n: { name: "Host · Segnalazioni", route: "/segnalazioni", position: {"x":5760,"y":2200} },
    scr_tuduld: { name: "Host · Storico", route: "/storico", position: {"x":7160,"y":2200} },
    scr_alke87: { name: "Host · Pacchetti pulizie", route: "/pacchetti", position: {"x":8560,"y":2200} },
    scr_0yufjc: { name: "Host · Scheda Proprietà", route: "/scheda-proprieta", position: {"x":9960,"y":2200} },
    scr_bbftm4: { name: "Host · Impostazioni", route: "/impostazioni", position: {"x":11360,"y":2200} },
    scr_7twik7: { name: "Host · Richiedi intervento", route: "/richiedi-intervento", position: {"x":15560,"y":2200} },
    scr_oqj0zi: { name: "Cleaner · Dashboard", route: "/cm", position: {"x":160,"y":4180} },
    scr_arseac: { name: "Cleaner · Opportunità (Lista)", route: "/cm/opportunita", state: {"view":"lista"}, position: {"x":1560,"y":4180} },
    scr_v72s7i: { name: "Cleaner · Opportunità (Mappa)", route: "/cm/opportunita", state: {"view":"mappa"}, position: {"x":11360,"y":4180} },
    scr_ndkf0l: { name: "Cleaner · Incarichi", route: "/cm/incarichi", position: {"x":2960,"y":4180} },
    scr_exfz2b: { name: "Cleaner · Proposte & Contratti", route: "/cm/proposte", position: {"x":4360,"y":4180} },
    scr_bv0ouz: { name: "Cleaner · Team", route: "/cm/team", position: {"x":5760,"y":4180} },
    scr_el5q8c: { name: "Cleaner · Qualità", route: "/cm/qualita", position: {"x":7160,"y":4180} },
    scr_eobvbs: { name: "Cleaner · Guadagni", route: "/cm/guadagni", position: {"x":8560,"y":4180} },
    scr_h3he8s: { name: "Cleaner · Impostazioni", route: "/cm/impostazioni", position: {"x":9960,"y":4180} },
    scr_r4od4t: { name: "Manutentore · Dashboard", route: "/man", position: {"x":160,"y":6160} },
    scr_2p6avh: { name: "Manutentore · Opportunità di zona", route: "/man/opportunita", position: {"x":1560,"y":6160} },
    scr_h1yumq: { name: "Manutentore · Incarichi", route: "/man/incarichi", position: {"x":2960,"y":6160} },
    scr_z3sztu: { name: "Manutentore · Guadagni", route: "/man/guadagni", position: {"x":4360,"y":6160} },
  },
  sections: {
    sec_3ksq1z: { name: "Onboarding flow", x: 0, y: 0, width: 7120, height: 1180 },
    sec_rtvc04: { name: "Host platform", x: 0, y: 1980, width: 16920, height: 1180 },
    sec_pkiyt4: { name: "Cleaner platform", x: 0, y: 3960, width: 12720, height: 1180 },
    sec_mh33wt: { name: "Manutentore platform", x: 0, y: 5940, width: 9920, height: 1180 },
    sec_zc9zk0: { name: "Authentication", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3ksq1z", children: [
      { kind: "screen", id: "scr_jc6tma" },
      { kind: "screen", id: "scr_d4b2vx" },
      { kind: "screen", id: "scr_efldtk" },
      { kind: "screen", id: "scr_wfdb55" },
      { kind: "screen", id: "scr_275qvc" },
    ] },
    { kind: "section", id: "sec_rtvc04", children: [
      { kind: "screen", id: "scr_hiospa" },
      { kind: "screen", id: "scr_wy1yyd" },
      { kind: "screen", id: "scr_2mhfpz" },
      { kind: "screen", id: "scr_wyjele" },
      { kind: "screen", id: "scr_uxqp9n" },
      { kind: "screen", id: "scr_tuduld" },
      { kind: "screen", id: "scr_alke87" },
      { kind: "screen", id: "scr_0yufjc" },
      { kind: "screen", id: "scr_bbftm4" },
      { kind: "screen", id: "scr_ifs7ub" },
      { kind: "screen", id: "scr_lcphm3" },
      { kind: "screen", id: "scr_7twik7" },
    ] },
    { kind: "section", id: "sec_pkiyt4", children: [
      { kind: "screen", id: "scr_oqj0zi" },
      { kind: "screen", id: "scr_arseac" },
      { kind: "screen", id: "scr_ndkf0l" },
      { kind: "screen", id: "scr_exfz2b" },
      { kind: "screen", id: "scr_bv0ouz" },
      { kind: "screen", id: "scr_el5q8c" },
      { kind: "screen", id: "scr_eobvbs" },
      { kind: "screen", id: "scr_h3he8s" },
      { kind: "screen", id: "scr_v72s7i" },
    ] },
    { kind: "section", id: "sec_mh33wt", children: [
      { kind: "screen", id: "scr_r4od4t" },
      { kind: "screen", id: "scr_2p6avh" },
      { kind: "screen", id: "scr_h1yumq" },
      { kind: "screen", id: "scr_z3sztu" },
    ] },
    { kind: "section", id: "sec_zc9zk0", children: [
      { kind: "screen", id: "scr_wxnbp6" },
    ] },
  ],
}
